<!--Global elements-->
<jb-growl-pop-up></jb-growl-pop-up>
<jb-loading-bar></jb-loading-bar>

<!--Shell elements-->
<app-navbar></app-navbar>
<!--<app-menu *ngIf="profile.isLoggedIn"></app-menu>-->
<app-profile *ngIf="profile.isLoggedIn"></app-profile>

<!--Routing container-->
<div class="container-fluid route-container">
  <router-outlet></router-outlet>
</div>

